<div class="container-fluid">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/patients'"> Patients </a>
            </li>
            <li
              aria-current="page"
              class="breadcrumb-item active text-gray psp-breadcrumb"
            >
              Patient Profile
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="border-bottom title d-flex p-3 align-items-center mt-2">
      <h2 class="m-0">Patient Profile</h2>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <a class="back-btn" [routerLink]="['/patient-details', patientId]">
        <i class="fa fa-arrow-left"></i>
        Back to EMR
      </a>
      <div class="table-title">
        <h3 class="title">Medications</h3>
      </div>
      <div class="filter-btns mb-3">
        <h5 class="title">Filter By</h5>
        <div class="filter-btn-container">
          <button
            class="btn filter-btn"
            [class.active-btn]="
              prescriptionCreatorType == prescriptionTypeEnum.all
            "
            (click)="onGetPrescriptions(prescriptionTypeEnum.all)"
          >
            All
          </button>
          <button
            class="btn filter-btn"
            [class.active-btn]="
              prescriptionCreatorType == prescriptionTypeEnum.patient
            "
            (click)="onGetPrescriptions(prescriptionTypeEnum.patient)"
          >
            Added by Patient
          </button>
          <button
            class="btn filter-btn"
            [class.active-btn]="
              prescriptionCreatorType == prescriptionTypeEnum.doctor
            "
            (click)="onGetPrescriptions(prescriptionTypeEnum.doctor)"
          >
            Prescribed by Doctor
          </button>
          <button
            class="btn filter-btn"
            [class.active-btn]="
              prescriptionCreatorType == prescriptionTypeEnum.admin
            "
            (click)="onGetPrescriptions(prescriptionTypeEnum.admin)"
          >
            Prescribed by Admin
          </button>
        </div>
      </div>
      <div
        *ngIf="prescriptionList?.length"
        class="table-responsive"
        infinite-scroll
        [infiniteScrollDistance]="0"
        [infiniteScrollThrottle]="0"
        [scrollWindow]="false"
        (scrolled)="handlePrescriptionPagination()"
      >
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of prescriptionThead">
                {{ th | uppercase }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let prescription of prescriptionList; index as i"
              (click)="
                onEmrPrescriptionDetails(
                  prescription.isClickable,
                  prescription.sourceType,
                  prescription.id
                )
              "
              [class.disabled]="!prescription.isClickable"
              placement="top"
              [tooltip]="
                prescription.isClickable
                  ? ''
                  : 'This prescription isn\'t clickable!'
              "
            >
              <td>
                <span>{{
                  prescription.creationDate?.split("T")[0] || "--"
                }}</span>
              </td>
              <td>
                <span>{{ getChannelType(prescription.channelId) }}</span>
              </td>
              <td>
                <span>{{ prescription.medicationsCount }}</span>
              </td>
              <td>
                <span>{{ prescription.title || "--" }}</span>
              </td>
              <td>
                <span>{{ prescription.notes || "--" }}</span>
              </td>
              <td>
                <span>{{
                  getEhrType(
                    prescription.ehrTypeIds,
                    prescription.uploadedPrescriptionTypeId
                  )
                }}</span>
              </td>
              <td>
                <span *ngIf="prescription.attachmentUrls?.length" class="link" (click)="viewFiles($event, prescription)">
                  Upload Files
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" *ngIf="!prescriptionList?.length">
        <div class="col-12 py-3">Hmm, There is no Prescriptions</div>
      </div>
    </div>
  </div>
</div>
